import React, { useState } from 'react';
import { Dropdown, FormControl, InputGroup } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from '../../store/store';
import { getActiveBrand, getUserBrands } from '../../store/selector/brand.selector';
import { IBrand } from '../../interfaces/brand.interface';
import { IncreaseResetStoreCounter, SetChangeBrandLoading } from '../../store/slice/common.slice';
import { setBrandChangeState } from '../../utils/state.utils';
import { SetActiveBrand } from '../../store/slice/brand.slice';
import { SetUserCurrentlyWorkingBrandId } from '../../store/slice/user.slice';
import { useUpdateCurrentlyWorkingBrandIdMutation } from '../../store/api/user.api';

const BrandsDropdown = () => {
    const dispatch = useAppDispatch();
    const activeBrand = useAppSelector(getActiveBrand);
    const userBrands = useAppSelector(getUserBrands);
    const [updateCurrentlyWorkingBrandId] = useUpdateCurrentlyWorkingBrandIdMutation();

    const [searchedBrandText, setSearchedBrandText] = useState('');

    const handleBrandChange = async (brand: IBrand) => {
        if (activeBrand && activeBrand.id === brand.id) {
            setSearchedBrandText('');
            return;
        }
        dispatch(SetChangeBrandLoading(true));
        setBrandChangeState(dispatch);
        dispatch(SetActiveBrand(brand));
        dispatch(SetUserCurrentlyWorkingBrandId(brand.id));
        dispatch(IncreaseResetStoreCounter());
        await updateCurrentlyWorkingBrandId({ brandId: brand.id });
        dispatch(SetChangeBrandLoading(false));
        setSearchedBrandText('');
    };

    return (
        <>
            {activeBrand && userBrands.length > 0 && (
                <InputGroup className="custom-dropdown tw-w-full">
                    <Dropdown>
                        <Dropdown.Toggle
                            variant="outline-primary"
                            id="dropdown-basic"
                            className="dropdown__toggle tw-w-full tw-flex tw-items-center !tw-justify-between"
                        >
                            <span
                                style={{
                                    maxWidth: '160px',
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis',
                                    display: 'inline-block',
                                    fontSize: '15px',
                                }}
                            >
                                {activeBrand.name}
                            </span>
                            <i className="ph ph-caret-down md"></i>
                        </Dropdown.Toggle>

                        <Dropdown.Menu className="dropdown__toggle--menu tw-w-full" align="start">
                            {userBrands.length > 5 && (
                                <div className="py-2">
                                    <FormControl
                                        placeholder="Search brands..."
                                        aria-label="Search"
                                        onChange={(e) => setSearchedBrandText(e.target.value)}
                                    />
                                </div>
                            )}

                            <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                {userBrands.map((brand) => {
                                    if (brand.name.toLowerCase().includes(searchedBrandText)) {
                                        return (
                                            <Dropdown.Item
                                                key={brand.id}
                                                onClick={() => handleBrandChange(brand)}
                                                className={
                                                    activeBrand.id === brand.id ? 'active' : ''
                                                }
                                                style={{
                                                    maxWidth: '250px',
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    display: 'block',
                                                    fontSize: '14px',
                                                }}
                                            >
                                                {brand.name}
                                            </Dropdown.Item>
                                        );
                                    } else return <></>;
                                })}
                            </div>
                        </Dropdown.Menu>
                    </Dropdown>
                </InputGroup>
            )}
        </>
    );
};

export default BrandsDropdown;
